import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import classNames from 'classnames';
import Link from 'next/link';
import React, { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * UI component with avatar, title and description
 */
export var AvatarBlurb = function AvatarBlurb(_ref) {
  var avatarUrl = _ref.avatarUrl,
      title = _ref.title,
      titleURL = _ref.titleURL,
      description = _ref.description,
      avatarSize = _ref.avatarSize,
      propsTitleClasses = _ref.titleClasses,
      titleStyles = _ref.titleStyles,
      descriptionStyles = _ref.descriptionStyles,
      descriptionUrl = _ref.descriptionUrl;
  var titleClasses = "text-lg text-base font-semibold ".concat(propsTitleClasses);
  var initials = title && title[0].toUpperCase();

  var _useState = useState(!avatarUrl),
      hasError = _useState[0],
      setHasError = _useState[1];

  var handleError = function handleError() {
    return setHasError(true);
  };

  var style = {};
  if (avatarUrl) style.backgroundImage = "url(".concat(avatarUrl, ")");
  return /*#__PURE__*/_jsxs("div", {
    className: "flex",
    children: [/*#__PURE__*/_jsx("div", {
      className: classNames("flex rounded-full overflow-hidden flex-shrink-0", {
        'h-12 w-12': avatarSize === 'small',
        'h-14 w-14': avatarSize === 'medium'
      }),
      style: style,
      children: hasError ? /*#__PURE__*/_jsx("span", {
        className: "\n            flex items-center justify-center h-full w-full text-subkit-primary bg-subkit-alt-light\n            font-semibold text-lg flex-none\n          ",
        children: initials
      }) : descriptionUrl ? /*#__PURE__*/_jsx(Link, {
        href: descriptionUrl,
        passHref: true,
        children: /*#__PURE__*/_jsx("img", {
          src: avatarUrl,
          alt: title,
          className: "w-full cursor-pointer object-cover",
          onError: handleError
        })
      }) : /*#__PURE__*/_jsx("img", {
        src: avatarUrl,
        alt: title,
        className: "w-full cursor-pointer object-cover",
        onError: handleError
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col pl-4",
      children: [titleURL ? /*#__PURE__*/_jsx(Link, {
        href: titleURL,
        children: /*#__PURE__*/_jsx("a", {
          className: "".concat(titleClasses, " text-subkit-primary"),
          style: _objectSpread({}, titleStyles),
          children: title
        })
      }) : /*#__PURE__*/_jsx("span", {
        className: titleClasses,
        style: _objectSpread({}, titleStyles),
        children: title
      }), /*#__PURE__*/_jsx("span", {
        className: "text-base",
        style: _objectSpread({}, descriptionStyles),
        children: description
      })]
    })]
  });
};
AvatarBlurb.defaultProps = {
  avatarSize: 'medium',
  titleClasses: ''
};